import { Button } from "@trillion/ui/components/ui/button";
import type { SaveFailure } from "../lib/use-diagram-save";
import type { RecoveryDocument } from "../lib/diagram-collaboration";

export function SaveRecoveryPanel({ failure, disabled, retryDisabled, onRetry, onDownload, onReload,
  copies = [], onDownloadCopy, onDiscardCopy }: {
  failure?: SaveFailure | null; disabled: boolean; retryDisabled?: boolean;
  onRetry: () => void; onDownload: () => void; onReload: () => void;
  copies?: RecoveryDocument[]; onDownloadCopy?: (copy: RecoveryDocument) => void; onDiscardCopy?: (id: string) => void;
}) {
  return <div role="alert" className="flex flex-wrap items-center gap-2 border-b bg-muted px-4 py-3 text-sm text-foreground">
    {failure && <>
      <p className="w-full">{failure.message}</p>
      {failure.kind === "failed" && <Button size="sm" disabled={disabled || retryDisabled} onClick={onRetry}>Retry save</Button>}
      <Button size="sm" variant="outline" onClick={onDownload}>Download local copy</Button>
      <Button size="sm" variant="outline" disabled={disabled} onClick={onReload}>Reload latest</Button>
    </>}
    {copies.length > 0 && <div className="w-full space-y-2">
      <p>Retained local copies stay in this tab. Download them before leaving.</p>
      {copies.map((copy, index) => <div key={copy.id} className="flex flex-wrap items-center gap-2">
        <span>Local copy {index + 1}: {copy.document.title} (base revision {copy.baseRevision})</span>
        <Button size="sm" variant="outline" onClick={() => onDownloadCopy?.(copy)}>Download copy {index + 1}</Button>
        <Button size="sm" variant="outline" onClick={() => onDiscardCopy?.(copy.id)}>Discard copy {index + 1}</Button>
      </div>)}
    </div>}
  </div>;
}
